import React from "react";
import { Helmet } from "react-helmet";

const SITE_URL = "https://www.edyn.care";
const DEFAULT_IMAGE = `${SITE_URL}/assets/marketing-site/images/open-graph-img.png`;

export default function Seo({
	title,
	description,
	path = "/",
	image = DEFAULT_IMAGE,
	children,
}) {
	const canonical = `${SITE_URL}${path}`;
	const organisationSchema = {
		"@context": "https://schema.org",
		"@type": "Organization",
		name: "Edyn Care",
		url: SITE_URL,
		logo: `${SITE_URL}/assets/marketing-site/images/logo.png`,
		telephone: "+442039709900",
		email: "hello@edyn.care",
		sameAs: [
			"https://uk.trustpilot.com/review/edyn.care",
			"https://www.facebook.com/EdynCare/",
			"https://twitter.com/EdynCare",
		],
	};
	const websiteSchema = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: "Edyn Care",
		url: SITE_URL,
	};

	return (
		<Helmet htmlAttributes={{ lang: "en-GB" }}>
			<meta charSet="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<title>{title}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={canonical} />
			<meta property="og:type" content="website" />
			<meta property="og:site_name" content="Edyn Care" />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonical} />
			<meta property="og:image" content={image} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
			<script type="application/ld+json">
				{JSON.stringify(organisationSchema)}
			</script>
			<script type="application/ld+json">
				{JSON.stringify(websiteSchema)}
			</script>
			{children}
		</Helmet>
	);
}
